module.exports = __webpack_public_path__ + "img/cib.fc39e328.png";